<div class="help-block">
  <span *ngIf="required && !hasErrors" class="info-messages">* Required</span>
  <ul *ngIf="hasErrors" class="error-messages list-unstyled">
    <li *ngFor="let message of uniqueMessages; index as i; trackBy: errorIdentity">
      {{ message }}
    </li>
  </ul>
</div>



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/error.component.html